/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import FadeInSection from "../../FadeInSection";
import axios from "../../../api/axiosService";
import { sanitize, getLocalized } from "../../../Common/Util";

export default function Culture(props) {
  const { t, i18n } = useTranslation();
  const [cultures, setCulture] = useState();
  const [cultureBanner, setCultureBanner] = useState();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const requests = [
        axios.get("/api/milestone/list"),
        axios.get("/api/milestone/banner"),
      ];

      const [milestoneResponse, bannerResponse] = await Promise.all(requests);

      // Validate response data before setting state
      if (milestoneResponse.data?.data) {
        setCulture(
          milestoneResponse.data.data.filter(
            (item, index) => item.title != "Milestone Page Banner",
          ),
        );
      }

      if (bannerResponse.data?.data?.banner) {
        setCultureBanner(bannerResponse.data.data.banner);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      // Xử lý lỗi tại đây
    }
  };

  return (
    <div className="culture-ssl w-100">
      <div className="culture-header global-header-block-1">
        <div className="text normal-text" style={{ fontWeight: 700 }}>
          {t("CREW")}
        </div>
        <h1
          className="title-1 global-title-margin header-title"
          style={{ fontWeight: 700 }}
        >
          {t("SSL_CULTURE")}
        </h1>
      </div>
      <div className="content">
        <img src={cultureBanner} className="banner w-full" />
        <div className="culture-list desktop-culture-list min-h-screen bg-black flex flex-col items-center relative">
          {/* Events */}
          {cultures?.map((event, index) => (
            <div
              key={index}
              className={`culture w-full ${
                index % 2 === 0 ? "content-right" : "content-left"
              }`}
            >
              {/* Content */}
              <FadeInSection delay={200} direction="down">
                <div className="desktop-timeline-row">
                  <div className="desktop-culture-copy">
                    <div className="title title-2 text-center">
                      {getLocalized(event, "title", i18n.language)}
                    </div>
                    <div
                      className="description normal-text"
                      dangerouslySetInnerHTML={sanitize(
                        getLocalized(event, "content", i18n.language),
                      )}
                    />
                  </div>
                  <div className="year normal-text text-center">
                    {event.year}
                  </div>
                </div>
              </FadeInSection>
            </div>
          ))}
          {/* Vertical line */}
          <div className="hr-divider divider absolute left-1/2 top-0 bottom-0"></div>
        </div>
        <div className="mobile-culture-list bg-black">
          {cultures?.map((event, index) => (
            <div key={index} className="mobile-culture-block">
              <FadeInSection delay={200} direction="down">
                <div className="mobile-culture-content">
                  <div className="mobile-culture-year normal-text">
                    {event.year}
                  </div>
                  <div className="mobile-culture-title title-2">
                    {getLocalized(event, "title", i18n.language)}
                  </div>
                  <div
                    className="mobile-culture-description normal-text"
                    dangerouslySetInnerHTML={sanitize(
                      getLocalized(event, "content", i18n.language),
                    )}
                  />
                </div>
              </FadeInSection>
              {index < cultures.length - 1 && (
                <div className="hr-divider divider mobile-culture-divider absolute left-1/2 top-0 bottom-0"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const contentsData = {
  banner:
    "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/Group+47.png",
  info: [
    {
      year: "2023",
      title: "harmonizing",
      description:
        '"KØDEINE - NEVASLEEP (Original Mix)" là sản phẩm tiếp theo được phát hành bởi WDND Label. Mang tinh thần "NEVASLEEP" của các "SPACEBOYS" quay trở lại ...',
    },
    {
      year: "2024 - 2025",
      title: "harmonizing",
      description:
        '"KØDEINE - NEVASLEEP (Original Mix)" là sản phẩm tiếp theo được phát hành bởi WDND Label. Mang tinh thần "NEVASLEEP" của các "SPACEBOYS" quay trở lại ...',
    },
    {
      year: "2026",
      title: "harmonizing",
      description:
        '"KØDEINE - NEVASLEEP (Original Mix)" là sản phẩm tiếp theo được phát hành bởi WDND Label. Mang tinh thần "NEVASLEEP" của các "SPACEBOYS" quay trở lại ...',
    },
    {
      year: "2027",
      title: "harmonizing",
      description:
        '"KØDEINE - NEVASLEEP (Original Mix)" là sản phẩm tiếp theo được phát hành bởi WDND Label. Mang tinh thần "NEVASLEEP" của các "SPACEBOYS" quay trở lại ...',
    },
  ],
};
